import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { LineChart } from "../../../charts/lineChart";
import { BarChart } from "../../../charts/barChart";
import { generateNewsGraphData, prepareGraphData } from "../../../../common/graphHelper";
import { getNewsTypeGraphInfo, getNewsUploadedGraphInfo } from "../../../../store/news/newsSlice";
import { ChartCall } from "../../../charts/chartCall";

const _props = {
  period: "",
  graphConfig:{},
  dataListTemplate:'',
  setSourceName:()=>{},
  setReset:()=>{}
};
export function NewsUploadedAnalytics(props = _props) {
  const [isMounted, setIsMounted] = useState(true);
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [],
    totalDatasets: 0,
  });


  useEffect(() => {
    async function fetchDataAndSetGraphData() {
      const data = await generateNewsGraphData(
        dispatch,
        props.period,
        props.graphConfig,
        isMounted
      );
      setGraphData({
        labels: data.labels,
        datasets: data.datasets,
        totalDatasets: data.total,
      });
    }
    fetchDataAndSetGraphData();
    
  }, [props.period, props.graphConfig]);

  useState(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);



  return (
    <div>
      <ChartCall
        chartType={props.graphConfig.chartType}
        setReset={props.setReset}
        config={{
          datasets: graphData.datasets,
          labels: graphData.labels,
          totalDatasets: graphData.totalDatasets,
          graphConfig: props.graphConfig,
          dataListTemplate:props.dataListTemplate,
          setSourceName:props.setSourceName
        }}
      />
    </div>
  );
}
